module.exports = __webpack_public_path__ + "static/media/honeybee.87fe8d34.jpg";